import { useEnvironmentData } from '@agyletime/vue-3-common/src/composables/environmentData';
import { mergeOptionsWithAuth } from '@agyletime/vue-3-common/src/utils/apiService';

const environmentData = await useEnvironmentData();

const sendToLambda = async (method: string, url: string, body?: string, options?: Record<string, unknown>) => {
    const optionsWithAuth = mergeOptionsWithAuth(options);
    return fetch(`${environmentData.apiGatewayBaseUrl}${url}`, {
        method,
        body,
        ...optionsWithAuth
    })
        .then((response) => {
            if (!response.ok) {
                const error = new Error(response.statusText);
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore TODO: Add status to Error
                error.status = response.status || 400;
                throw error;
            }
            if (response.status === 204) {
                return null;
            }
            return response.json();
        })
        .then((response) => response && response.data);
};

export const lambda = {
    post: async (url: string, body: string, options?: { headers: object }) => sendToLambda('POST', url, body, options),
    patch: async (url: string, body: string, options?: { headers: object }) => sendToLambda('PATCH', url, body, options),
    put: async (url: string, body: string, options?: { headers: object }) => sendToLambda('PUT', url, body, options),
    delete: async (url: string, options?: { headers: object }) => sendToLambda('DELETE', url, undefined, options)
};